import { createSlice } from "@reduxjs/toolkit";
import { Exam } from "./examSlice";
import {
  getVoucherByRequestId,
  getVouchersAtc,
  getVouchersPublic,
  getAtcVoucherByRequestId,
  filterVoucherAtc,
  filterPublicAtc,
} from "../apiActions/voucherActions";

interface Atc {
  name: string;
  id: string;
  created_at: string;
}

export type RequestAtc = {
  id: string;
  created_at: string;
  invoice_number: string;
  payment_id: string;
  status: string;
  amount: number;
  number_of_vouchers: number;
  user: string | null;
  atc: Atc;
  exam: Exam;
  comment: string;
};

interface VoucherState {
  loading: {
    getRequest: boolean;
    createExam: boolean;
    updateExam: boolean;
    deleteExam: boolean;
    voucherByRequestId: boolean;
  };
  deleteLoading: boolean;
  error: null | string;
  vouchersAtc: RequestAtc[];
  vouchersPublic: RequestAtc[];
  voucherByRequestId: RequestAtc[];
  modal: boolean;
}

const initialState: VoucherState = {
  vouchersAtc: [],
  vouchersPublic: [],
  voucherByRequestId: [],
  error: null,
  loading: {
    getRequest: false,
    updateExam: false,
    deleteExam: false,
    createExam: false,
    voucherByRequestId: false,
  },
  deleteLoading: false,
  modal: false,
};

const examSlice = createSlice({
  name: "request",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVouchersAtc.pending, (state: VoucherState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(getVouchersAtc.fulfilled, (state: VoucherState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.vouchersAtc = action.payload;
        state.modal = false;
      })
      .addCase(getVouchersAtc.rejected, (state: VoucherState, action) => {
        state.loading.getRequest = false;
      })
      .addCase(filterVoucherAtc.pending, (state: VoucherState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(filterVoucherAtc.fulfilled, (state: VoucherState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.vouchersAtc = action.payload;
        state.modal = false;
      })
      .addCase(filterVoucherAtc.rejected, (state: VoucherState, action) => {
        state.loading.getRequest = false;
      })

      .addCase(getVouchersPublic.pending, (state: VoucherState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(getVouchersPublic.fulfilled, (state: VoucherState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.vouchersPublic = action.payload;
        state.modal = false;
      })
      .addCase(getVouchersPublic.rejected, (state: VoucherState, action) => {
        state.loading.getRequest = false;
      })
      .addCase(filterPublicAtc.pending, (state: VoucherState) => {
        state.loading.getRequest = true;
        state.error = null;
      })
      .addCase(filterPublicAtc.fulfilled, (state: VoucherState, action) => {
        state.loading.getRequest = false;
        state.error = null;
        state.vouchersPublic = action.payload;
        state.modal = false;
      })
      .addCase(filterPublicAtc.rejected, (state: VoucherState, action) => {
        state.loading.getRequest = false;
      })
      .addCase(getVoucherByRequestId.pending, (state: VoucherState) => {
        state.loading.voucherByRequestId = true;
        state.error = null;
      })
      .addCase(
        getVoucherByRequestId.fulfilled,
        (state: VoucherState, action) => {
          state.loading.voucherByRequestId = false;
          state.error = null;
          state.voucherByRequestId = action.payload;
          state.modal = false;
        }
      )
      .addCase(
        getVoucherByRequestId.rejected,
        (state: VoucherState, action) => {
          state.loading.voucherByRequestId = false;
        }
      )
      .addCase(getAtcVoucherByRequestId.pending, (state: VoucherState) => {
        state.loading.voucherByRequestId = true;
        state.error = null;
      })
      .addCase(
        getAtcVoucherByRequestId.fulfilled,
        (state: VoucherState, action) => {
          state.loading.voucherByRequestId = false;
          state.error = null;
          state.voucherByRequestId = action.payload;
          state.modal = false;
        }
      )
      .addCase(
        getAtcVoucherByRequestId.rejected,
        (state: VoucherState, action) => {
          state.loading.voucherByRequestId = false;
        }
      );
  },
});

// export const {} = examSlice.actions;
export default examSlice.reducer;
